module.exports = __webpack_public_path__ + "static/media/marker-blue.aea671c7.svg";